export enum FloorplanLabelingMethod {
  LabelsInLegend = 'labels-in-legend',
  LabelsOnDiagram = 'labels-on-diagram',
}
